<template>
  <div>
    <authCheck :pageUser="pageUser" :pageDevice="pageDevice" :sid="sid" :pageSensor="pageSensor" :pageBindFinished="pageBindFinished">

      <div class="pageUserIcon" v-if="!presentationMode && pageUser && pageUser.photoURL">
        <b-img :src="pageUser.photoURL" @click="showPageUser" :alt="`${pageUser.displayName}의 사진`" v-b-tooltip :title="`${pageUser.displayName}의 정보 보기`" class="cursor-pointer"/>
      </div>

      <h1 class="documentTitle" v-if="pageUser && pageSensor && !presentationMode" v-touch:touchhold="togglePresentationMode" v-touch:swipe="swipeApp">

        <b-button @click="showPageUser" v-b-tooltip :title="(isLoginUserPageUser)?'나의 정보 보기':`${pageUser.displayName}의 정보 보기`" variant="secondary" size="lg" class="fontSize1Dot4 p-0 pl-1 pr-1 mr-1 displayNoneMax630">
          {{(isLoginUserPageUser)? '나': pageUser.displayName}}</b-button><small class="fontSize1Dot4 displayNoneMax630">의</small>

        <router-link :to="{ name: 'tinkSensor', params: { sid: sid, mode: 'grid' }}" class="fontSize1Dot6 narrowText" custom v-slot="{ navigate }">
          <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
            {{pageSensor.title}}
            <span class="displayNoneMax589">({{pageSensor.name}})</span>
          </span>  
        </router-link>

        <b-button
        v-if="pageDevice" :variant="(pageBinded)? 'primary': 'secondary'" size="sm" class="ml-1 mr-1 fontSizeDot8 pt-dot1 pb-dot1 pr-2 pl-2 narrowText2 borderRadiusDot75" :disabled ="toggleRealtimeDisabled" @click="toggleRealtimeChanged" v-b-tooltip.hover title="내 기기나 내가 관리하는 기기가 아니면 일정 시간이 지나면 실시간이 꺼집니다. 꺼짐이면 변경된 값을 받지 않습니다. 꺼짐이면 저장관련 버튼이 동작하지 않습니다.">
          <span class="displayNoneMax589">실시간</span>
          <span v-if="pageBinded">켜짐</span>
          <span v-else>꺼짐</span>
        </b-button>

        <b-button v-if="pageDevice" :variant="(pageDevice.active)? 'danger': 'secondary'" size="sm" class="ml-1 mr-1 fontSizeDot8 pt-dot1 pb-dot1 pr-2 pl-2 narrowText2 borderRadiusDot75" :disabled ="togglePageDeviceActiveDisabled || !isLoginUserPageUser" @click="toggleActiveChanged"
        v-b-tooltip.hover title="기기 꺼짐이면 IOT 기기에서 데이터를 보내더라도 저장되지 않습니다.">
          <span class="displayNoneMax589">업로드</span>
          <span v-if="pageDevice.active">켜짐</span>
          <span v-else>꺼짐</span>
        </b-button>
      </h1>

      <div v-if="!presentationMode && pageUser != null && pageDevice != null" class="pl-3 pt-1 pb-1 pr-1 bg-light gothic fontSizeDot9 border-top border-bottom controlRow" v-touch:touchhold="togglePresentationMode" v-touch:swipe="swipeApp">
        <div class="leftControl mt-1">
          <span class="font-weight-bold fontSizeDot7 text-secondary">&laquo;</span>
          <router-link :to="{ name: 'tinkUser', params: { uid: pageUser.id } }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{(isLoginUserPageUser)? '나': pageUser.displayName}}의
              기기 목록
            </span>  
          </router-link>
          <span  class="ml-1 font-weight-bold fontSizeDot7 text-secondary">&lsaquo;</span>

          <router-link :to="{ name: 'tinkDevice', params: { did: pageDevice.id } }" custom v-slot="{ navigate }">
            <b-button size="sm" variant="primary" @click="navigate" @keypress.enter="navigate" role="link" style="vertical-align: 1px;" class="mr-1 ml-2 pt-0 pb-0 pl-2 pr-2 cursor-pointer">
              {{pageDevice.name}}
            </b-button>
          </router-link>


        </div>
        <div class="mr-2 rightExpandControl">

          <span v-for="sensor, sensorName in pageDevice.sensors" :key="sensorName">

            <router-link v-if="typeof(sensor) == 'string'" :to="{ name: 'tinkSensor', params: { sid: sensor.split('/')[1] }, query: { mode : mode } }" custom v-slot="{ navigate }">
              <b-button size="sm" :variant="(pageSensor.name == sensorName)? 'primary':'secondary'" @click="navigate" @keypress.enter="navigate" role="link" class="btn pl-1 pr-1 pt-0 pb-0 ml-1 mr-1 mt-dot1 mb-dot1 fontSizeDot8 cursor-pointer" :disabled="(pageSensor.name == sensorName)? true: false">
                {{sensor.split('/')[1].substring(0,4)}}...
              </b-button>
            </router-link>

            <router-link v-else :to="{ name: 'tinkSensor', params: { sid: sensor.id }, query: { mode : mode }}" custom v-slot="{ navigate }">
              <b-button size="sm" :variant="(pageSensor.name == sensorName)? 'primary':'secondary'" @click="navigate" @keypress.enter="navigate" role="link" class="btn pl-1 pr-1 pt-0 pb-0 ml-1 mr-1 mt-dot1 mb-dot1 fontSizeDot8 cursor-pointer" :disabled="(pageSensor.name == sensorName)? true: false">
                {{sensor.title}}
              </b-button>
            </router-link>
          </span>
          <span class="fontSizeDot7 font-weight-bold text-secondary">&rsaquo;</span>
        </div>
      </div>

      <div v-if="pageUser != null && pageDevice != null && pageSensor != null" class="ml-3 mr-3 mb-3 mt-2">

        <sensorGraph v-if="mode=='graph'" :pageSensorHistory="pageSensorHistory" :pageUser="pageUser" :pageDevice="pageDevice" :pageSensor="pageSensor"  :key ="graphKey" :pFromId="pFromId" :pToId="pToId" :pFromBook="pFromBook" :pToBook="pToBook" :pFromDate="pFromDate" :pToDate="pToDate" :pFromDateEpoch="pFromDateEpoch" :pToDateEpoch="pToDateEpoch" :pPresentation="pPresentation" :pScopeControl="pScopeControl" :pSubControl="pSubControl" :pHeight="pHeight" :pOverflowY="pOverflowY" :pGroupBy="pGroupBy" :pColumns="pColumns" :pXMin="pXMin" :pXMax="pXMax" :pChartOptions="pChartOptions"/>

        <sensorDownload v-else-if="mode=='download'" :pageUser="pageUser" :pageDevice="pageDevice" :pageSensor="pageSensor"  :pageBinded="pageBinded" :pageSensorHistory="pageSensorHistory"/>

        <sensorUpload v-else-if="mode=='upload' &&  isLoginUserItemWritable(this.pageSensor)" :pageUser="pageUser" :pageDevice="pageDevice" :pageSensor="pageSensor"  :pageBinded="pageBinded" :pageSensorHistory="pageSensorHistory"/>

        <sensorGrid v-else :pageSensorHistory="pageSensorHistory" :pageUser="pageUser" :pageDevice="pageDevice" :pageSensor="pageSensor" :pageBinded="pageBinded" :key ="gridKey" :pFromId="pFromId" :pToId="pToId" :pFromBook="pFromBook" :pToBook="pToBook" :pFromDate="pFromDate" :pToDate="pToDate" :pFromDateEpoch="pFromDateEpoch" :pToDateEpoch="pToDateEpoch" :pPresentation="pPresentation" :pEditControl="pEditControl" :pScopeControl="pScopeControl" :pSubControl="pSubControl" :pPageControl="pPageControl" :pHeight="pHeight" :pOverflowY="pOverflowY" :pGroupBy="pGroupBy" :pColumns="pColumns" :pPerPage="pPerPage" :pCurrent="pCurrent" :pSortBy="pSortBy" :pSortDesc="pSortDesc"/>

        <tPageUser :pageUser="pageUser" :pageDevice="pageDevice"/>

      </div>
    </authCheck>
  </div>
</template>
<script>

  import firebase from "firebase/app";
  import "firebase/auth";
  import "firebase/firestore";
  import { db } from "@/plugins/firebase.js";

  import uiUtil from "@/mixins/util.js";
  import user from "@/mixins/user.js";

  import authCheck from "@/components/authCheck.vue";
  import sensorGrid from "@/components/sensor/sensorGrid.vue";
  import sensorGraph from "@/components/sensor/sensorGraph.vue";
  import sensorUpload from "@/components/sensor/sensorUpload.vue";
  import sensorDownload from "@/components/sensor/sensorDownload.vue";
  import tPageUser from "@/components/tPageUser.vue"

  import eventBus from "@/plugins/eventBus.js"

  export default {
    name: "tinkSensor",
    mixins: [uiUtil, user],
    props: {
      sid: {
        type: String,
        default: ""
      },
      mode: {
        type: String,
        default: "grid"
      },
      pFromId: { type: Number, default: null },
      pToId: { type: Number, default: null },
      pFromBook: { type: Number, default: null },
      pToBook: { type: Number, default: null },
      pFromDate: { type: String, default: "" },
      pToDate: { type: String, default: "" },
      pFromDateEpoch: { type: Number, default: null},
      pToDateEpoch: { type: Number, default: null},
      pPresentation: { type: Boolean, default: false },
      pEditControl: { type: Boolean, default: true },
      pScopeControl: { type: Boolean, default: true },
      pSubControl: { type: Boolean, default: true },
      pPageControl: { type: Boolean, default: true },
      pHeight: { type: String, default: "" },
      pOverflowY: { type: String, default: "" },
      pGroupBy: { type: String, default: "" },
      pColumns: { type: String, default: "" },
      pPerPage: { type: Number, default: null },
      pXMin: { type: Number, default: null },
      pXMax: { type: Number, default: null },
      pCurrent: { type: Number, default: null },
      pSortBy: { type: String, default: "" },
      pSortDesc: { type: Boolean, default: true },
      pChartOptions: { type: String, default: "" },
    },

    components: {
      authCheck,
      sensorGrid,
      sensorGraph,
      sensorUpload,
      sensorDownload,
      tPageUser
    },

    data: function () {
      return {

        gridKey: 0,
        graphKey: 0,

        pageDeviceBinded: null,
        pageUserBinded: null,
        pageSensorBinded: null,

        pageSensorHistory: {},

        pageBinded: false,
        pageBindFinished: false,

        togglePageDeviceActiveDisabled: false,

        pageTimer: null,
        toggleRealtimeDisabled: true,
      }
    },

    created: function() {
    },
    mounted: function() {
      firebase.auth().onAuthStateChanged(() => {
        if(firebase.auth().currentUser != null) {
          this.doBindPageSensorOnce();
          this.$log.debug(this.pageUser, this.pageDevice, this.pageSensor);
        }
      })
    },
    updated: function() {
      this.$log.debug(this.pageUser, this.pageDevice, this.pageSensor);
    },
    beforeDestroy() {
      if(this.pageTimer) {
        window.clearTimeout(this.pageTimer);
        this.pageTimer = null;
      }
    },
    methods: {
      swipeApp: function(direction) {
        this.$log.debug("swife", direction);
        if(direction == "left") {
          eventBus.$emit("busUiShow", "myMenuShow");
          eventBus.$emit("busShowPageUser", false);
        }
        else if(direction == "right") {
          eventBus.$emit("busUiHide", "myMenuShow");
          eventBus.$emit("busShowPageUser", true);
        }
      },
      
      resetGrid: function() {
        this.gridKey++
      },

      resetGraph: function() {
        this.graphKey++
      },


      toggleRealtimeChanged: function() {

        if(this.pageBinded) {
          this.unbindPageSensor();
          this.toggleRealtimeDisabled = true;
          window.setTimeout(() => {
            this.toggleRealtimeDisabled = false;
          }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);
        }
        else {
          this.bindPageSensor();
        }
      },

      toggleActiveChanged: function() {
        if(this.pageDevice.active) {
          this.pageDevice.active = false;
          this.togglePageDeviceActiveDisabled = true;
          window.setTimeout(() => {
            this.togglePageDeviceActiveDisabled = false;
          }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);
        }
        else {
          this.pageDevice.active = true;
        }
        db.collection("devices").doc(this.pageDevice.id).update({
          active: this.pageDevice.active
        });
      },

      doBindPageSensorOnce: function() {
        if(this.loginUserBinded) {
          this.bindPageSensor();
        }
        else {
          if(!this.notLoginConfirmed) {
            window.setTimeout(()=> {
              this.doBindPageSensorOnce();
            },1000);
          }
        }
      },

      bindPageSensor: function() {

        let foundSensor = null;

        if(this.loginUserDeepBinding) {
          foundSensor = this.searchLoginUserSensor(this.sid);
        }

        if(foundSensor != null) {
          this.toggleRealtimeDisabled = true;
          this.pageBinded = true;
          this.pageBindFinished = true;
        }
        else {
          this.$bind("pageSensorBinded", db.collection("sensors").doc(this.sid), {
            maxRefDepth: 0,
            reset: false
          })
          .then(() => {
            this.$bind("pageDeviceBinded", db.collection("devices").doc(this.pageSensorBinded.device), {
              maxRefDepth: 1,
              reset: false
            })
            .then(() => {
              this.$bind("pageUserBinded", db.collection("users").doc(this.pageSensorBinded.owner), {
                maxRefDepth: 0,
                reset: false
              })
              .then(() => {
                this.pageBinded = true;
                this.pageBindFinished = true;

                this.toggleRealtimeDisabled = true;
                window.setTimeout(() => {
                  this.toggleRealtimeDisabled = false;
                }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);

                this.pageTimer = window.setTimeout(this.unbindPageSensor, process.env.VUE_APP_PAGE_TIMEOUT*1);
              })
              .catch((error) => {
                this.pageBinded = false;
                this.pageBindFinished = true;
                console.log(error);
              })
            })
            .catch((error) => {
              console.log(error);
              this.pageBinded = false;
              this.pageBindFinished = true;
            })
          })
          .catch((error) => {
            console.log(error);
            this.pageBinded = false;
            this.pageBindFinished = true;
          })
        }
      },

      unbindPageSensor: function() {
        if(this.pageBinded) {
          if(this.pageSensorBinded != null) this.$unbind("pageSensorBinded", false);
          if(this.pageDeviceBinded != null) this.$unbind("pageDeviceBinded", false);
          if(this.pageUserBinded != null) this.$unbind("pageUserBinded", false);
          this.pageBinded = false;
          this.pageTimer = null;
        }
      },
    },
    computed: {

      pageSensor: function() {
        if(!this.pageBindFinished) {
          return null;
        }
        else if(this.pageSensorBinded) {
          return this.pageSensorBinded;
        }
        else {
          let foundSensor = this.searchLoginUserSensor(this.sid);
          this.$log.debug("foundSensor", foundSensor);
          return foundSensor;
        }
      },

      pageDevice: function() {
        if(!this.pageBindFinished || !this.pageSensor) {
          return null;
        }
        else if(this.pageDeviceBinded != null) {
          return this.pageDeviceBinded;
        }
        else {
          return this.loginUserDeviceList[this.pageSensor.device];
        }
      },

      pageUser: function() {
        if(!this.pageBindFinished || !this.pageSensor || ! this.pageDevice) {
          return null;
        }
        else if(this.pageUserBinded != null) {
          return this.pageUserBinded;
        }
        else {
          return this.loginUser;
        }
      },
    },

    watch: {
      sid: function() {
        if(this.pageTimer != null) {
          window.clearTimeout(this.pageTimer);
        }
        this.gridKey = 0;
        this.pageDeviceBinded = null;
        this.pageUserBinded = null;
        this.pageSensorBinded = null;
        this.pageSensorHistory = {};
        this.pageBinded = false;
        this.pageBindFinished = false;
        this.togglePageDeviceActiveDisabled = false;
        this.pageTimer = null;
        this.toggleRealtimeDisabled = true;

        window.setTimeout(() => {
          this.doBindPageSensorOnce();
        }, 100);
      },
    },
  }
</script>
